import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
	colors: {
		gray: {
			"1000": "#333",
			"900": "#181823",
			"800": "#1f2029",
			"700": "#353646",
			"600": "#4b4d63",
			"500": "#616480",
			"400": "#797d9a",
			"300": "#9699b0",
			"200": "#b3b5c6",
			"100": "#d1d2dc",
			"50": "#eeeef2",
			"40": "#f5f5f5",
			"30": "#fafafa"
		},
		blue: {
			"900": "#0D47A1",
			"800": "#1565C0",
			"500": "#1a83ff", // "#2196f3",
			"200": "#90CAF9",
			"100": "#BBDEFB",
		},
		green: {
			"800": "#2E7D32"
		},
		red: {
			"900": "#B71C1C",
			"800": "#C62828",
			"400": "#EF5350",
			"300": "#E57373",
			"200": "#EF9A9A",
			"100": "#FFCDD2",
			"50": "#FFEBEE"
		}
	},
  fonts: {
    heading: 'Poppins',
    body: 'Poppins',
  },
  styles: {
    global: {
			// PARA NÃO APARECER OS SCROLLS NO FIREFOX
			'*': {
				scrollbarWidth: 'none'
			},
			//
      body: {
        bg: 'white',
        color: 'gray.900',

				// PARA NÃO APARECER OS SCROLLS NO CHROME
				'::-webkit-scrollbar': {
					display: 'none',
					visibility: 'hidden',
				},
				'div::-webkit-scrollbar, ul::-webkit-scrollbar': {
					display: 'none',
					visibility: 'hidden',
				},
				//
      },
    },
  },
});
